import React from 'react'
import './style.scss'

const PrimaryBtn = ({ text, onClick, disabled, small, classes }) => {
    return (
        <button className={`primary__btn ${small ? 'smal__btn' : ''} ${classes ?? ""}`} onClick={onClick} disabled={disabled}>
            {text}
        </button>
    )
}

export default PrimaryBtn